import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface DefaultAccordionStateDetails {
    value: any;
}



const initialState: DefaultAccordionStateDetails = {
    value : ''
};



const setDefaultAccordionStateDetailsSlice = createSlice({
  name: "setDefaultAccordionStateValue",
  initialState: initialState,
  reducers: {
    setDefaultAccordionStateDetails: (state,  action: PayloadAction<any>) => {
      state.value = action.payload;
    }
  }
});

export const { setDefaultAccordionStateDetails } = setDefaultAccordionStateDetailsSlice.actions;

export default setDefaultAccordionStateDetailsSlice.reducer;